var Destructor = new Class({
	destruct: function(scope) {
		scope = scope || window;
		var name = Object.keyOf(scope, this);
		this.fireEvent && this.fireEvent('destroy');
		//console.log('destroying ', name);
	 	if(scope[name]){
	 		try {
		 		delete scope[name];
	 		} catch (er) { scope[name] = null; }
	 	}
	}
});